import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, Warning, Spinner, Clock } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function NotifyAck() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${BASE}/api/public/notification-ack/${token}`);
        setState({ loading: false, ok: true, data });
      } catch (e) {
        setState({ loading: false, ok: false,
          error: e.response?.data?.detail || "Link expired or invalid" });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6" data-testid="notify-ack-page">
      <div className="max-w-lg w-full bg-white border-2 border-[#0f172a] p-8 shadow-2xl">
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-2">
          Field Radar · Escalation Chain
        </div>
        {state.loading && (
          <div className="flex items-center gap-3 text-slate-700">
            <Spinner weight="bold" size={24} className="animate-spin"/>
            <span className="font-bold">Confirming acknowledgment…</span>
          </div>
        )}
        {!state.loading && state.ok && (
          <>
            {state.data?.state === "resolved" ? (
              <div className="flex items-start gap-3 text-emerald-800">
                <CheckCircle weight="fill" size={28}/>
                <div>
                  <h1 className="font-display font-black text-2xl">Ticket Already Resolved</h1>
                  <p className="mt-2 text-sm">This request has already been marked resolved — no further action needed.</p>
                </div>
              </div>
            ) : state.data?.state === "already_acknowledged" ? (
              <div className="flex items-start gap-3 text-amber-800">
                <Clock weight="fill" size={28}/>
                <div>
                  <h1 className="font-display font-black text-2xl">Already Acknowledged</h1>
                  <p className="mt-2 text-sm">{state.data.message}</p>
                  {state.data.paused_until && (
                    <p className="mt-1 text-xs font-mono text-slate-500">Paused until: {new Date(state.data.paused_until).toLocaleString()}</p>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex items-start gap-3 text-emerald-800">
                <CheckCircle weight="fill" size={28}/>
                <div>
                  <h1 className="font-display font-black text-2xl">Got It — Chain Paused</h1>
                  <p className="mt-2 text-sm text-slate-700">{state.data.message}</p>
                  {state.data.paused_until && (
                    <p className="mt-2 text-xs font-mono text-slate-500">
                      Auto-resume: {new Date(state.data.paused_until).toLocaleString()}
                    </p>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        {!state.loading && !state.ok && (
          <div className="flex items-start gap-3 text-red-800" data-testid="notify-ack-error">
            <Warning weight="fill" size={28}/>
            <div>
              <h1 className="font-display font-black text-2xl">Link Invalid</h1>
              <p className="mt-2 text-sm">{state.error}</p>
              <p className="mt-2 text-xs text-slate-500">
                If you believe this is a mistake, please contact Field Radar support.
              </p>
            </div>
          </div>
        )}
        <div className="mt-8 pt-4 border-t border-slate-200 text-[10px] font-black uppercase tracking-widest text-slate-400">
          Field Radar · Intelligent Property Operations
        </div>
      </div>
    </div>
  );
}
